import * as yup from 'yup';

export const schema = yup.object().shape({
  documents: yup.array().min(1, 'errors.uploadSignedDocuments'),
});
